import React, { useState } from 'react';
import './ApiDetails.css';
import RedirectURL from '../common/RedirectURL';
import { formatPhoneNumber } from '../../utils/format-data.js';
import { Column, Grid, Row, SecondaryButton, withTooltip, IconOpenInNew } from 'cdk-radial';
import { APIDetailsHeader } from '../common/ApiDetailsTabHeader';
import ContactSupportDialog from './ContactSupportDialog.js';

const contactTypesMap = {
  general: 'General Questions',
  sales: 'Sales',
  support: 'Technical Support'
};

const renderNoSupportTxt = () => {
  return (
    <div>
      <div className="api-dir-pkg_no-documentation-text">
        The API provider does not have any contact information available at this
        time.
      </div>
    </div>
  );
};

const RedirectURLComponent = (props) => {
  const { website } = props;
  return (
    <RedirectURL
      classes="api-dir-pkg_api-doc-name api-dir-pkg_api-redirect"
      url={
        website.startsWith('http')
          ? website
          : `http://${website}`
      }
      heading={'Visit Site'}
      icon={<IconOpenInNew
        height={16}
        width={16}
        className='api-dir-pkg_icon'
      />}
      {...props}
    />
  )
};

const urlWithTooltipRenderer = props => {
  const tooltipProps = {
    id: 'website-url-id-1',
    text: props.website
  };
  const ComponentWithTooltip = withTooltip(RedirectURLComponent, tooltipProps);
  return <ComponentWithTooltip {...props} />;
};

const RenderSupportInfo = ({ contactInfo, contactType, ...props }) => {
  const [contactSupportModal, setContactSupportModalVisbility] = useState(
    false
  );
  let phoneNumber = contactInfo.phone;
  let email = contactInfo.email;
  let website = contactInfo.url;
  let orgName;
  if (props.orgName) {
    orgName = props.orgName;
  }
  let apiName;
  if (props.apiInfo.data) {
    apiName = props.apiInfo.data.name;
  }
  if (phoneNumber || email || website) {
    return (
      <div>
        <div>
          <div>
            <div className="api-dir-pkg_contact-information">
              {contactTypesMap[contactType]}
            </div>
            <div className="api-dir-pkg_contact-address">
              {phoneNumber
                ? formatPhoneNumber(phoneNumber) || phoneNumber
                : null}
              {contactInfo.phoneExt ? ' Ext: ' + contactInfo.phoneExt : ''}
              {phoneNumber ? <br /> : null}
            </div>
            {website && urlWithTooltipRenderer({ website })}
          </div>
          {email && (
              <SecondaryButton
                id="ContactSupportButton"
                data-testid="contact-support"
                className="api-dir-pkg_contact-support"
                onClick={() => {
                  setContactSupportModalVisbility(true);
                }}
                text="Contact"
              />
            )}
        </div>
        <ContactSupportDialog
          {...props}
          open={contactSupportModal}
          orgName={orgName}
          providerName={contactInfo.name}
          providerSupportEmail={email}
          apiName={apiName}
          onClose={() => {
            setContactSupportModalVisbility(false);
          }}
        />
      </div>
    );
  } else {
    return null;
  }
};

const filterContactInfo = apiInfo => {
  let contactData = {};
  if (
    apiInfo &&
    apiInfo.data &&
    apiInfo.data.contact &&
    Object.keys(apiInfo.data.contact).length
  ) {
    Object.keys(apiInfo.data.contact).forEach(contactType => {
      if (
        Object.keys(contactTypesMap).includes(contactType) &&
        typeof apiInfo.data.contact[contactType] === 'object' &&
        (apiInfo.data.contact[contactType].email ||
          apiInfo.data.contact[contactType].phone ||
          apiInfo.data.contact[contactType].url)
      ) {
        contactData[contactType] = apiInfo.data.contact[contactType];
      }
    });
  }
  return contactData;
};

const ApiSupport = props => {
  const { apiDetailsOnClickHandlers } = props;
  const contacts = filterContactInfo(props.apiInfo);
  let apiName;
  if (props.apiInfo && props.apiInfo.data) {
    apiName = props.apiInfo.data.name;
  }
  return (
    <>
      <div>
        <APIDetailsHeader title="API Contacts" />
        <div className="api-dir-pkg_contact_text_description" data-cy="contact-description">
          {`For support with ${apiName}, please contact us via the contact option(s) found below.`}
        </div>
        {Object.keys(contacts).length ? (
          <Grid>
            <Row style={{ padding: '0px' }}>
              {Object.keys(contacts).map((contactType, idx) => {
                return (
                  <Column l={4} m={4} s={6} xs={6} key={idx}>
                    <RenderSupportInfo
                      contactType={contactType}
                      contactInfo={contacts[contactType]}
                      {...props}
                    />
                  </Column>
                );
              })}
            </Row>
          </Grid>
        ) : (
          renderNoSupportTxt()
        )}
      </div>
    </>
  );
};

export default ApiSupport;
